module.exports = __webpack_public_path__ + "static/media/spacey-2026-3d.fd1ba5fd.svg";